/** @format */

import { useState } from "react";
// import Icon from "../Icon";

const Input = ({
  name,
  type,
  labelClassName,
  className,
  label,
  textarea,
  ...props
}) => {
  const fileTypeClasses = ` form-control-file`;

  const [showPassword] = useState(false);

  // const togglePasswordVisibility = () => {
  //   setShowPassword(!showPassword);
  // };

  return (
    <div>
      {label && (
        <label htmlFor={name} className={`${labelClassName} form-label `}>
          {label}
        </label>
      )}
      {textarea ? (
        <div className="position-relative">
          <textarea
            {...props}
            id={name}
            name={name}
            className={`form-control ${className}`}
          />
        </div>
      ) : (
        <div className="position-relative">
          <input
            {...props}
            type={type === "password" && showPassword ? "text" : type}
            id={name}
            name={name}
            className={`input-k ${type === "file" ? fileTypeClasses : ""}`}
          />
        </div>
      )}
    </div>
  );
};
export default Input;
